import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Clock, Building2 } from 'lucide-react';

const RoleCard = ({ role }) => {
  return (
    <Link to={`/roles/${role.id}`}>
      <div className="bg-white rounded-2xl p-5 min-w-[280px] max-w-[280px] border border-gray-100 hover:shadow-xl hover:border-indigo-100 transition-all duration-300 hover:-translate-y-1 cursor-pointer group flex flex-col h-[180px]">
        {/* Top Content */}
        <div className="flex-1">
          {/* Title */}
          <h3 className="font-semibold text-gray-900 mb-1 text-sm leading-tight line-clamp-2 group-hover:text-indigo-600 transition-colors">
            {role.title}
          </h3>
          
          {/* Company */}
          <div className="flex items-center gap-1.5 text-gray-500 text-xs mb-2">
            <Building2 className="w-3 h-3" />
            <span>{role.company}</span>
          </div>
          
          {/* Pay Rate */}
          <p className="text-indigo-600 font-semibold text-sm mb-3">{role.payRange}</p>
          
          {/* Tags */}
          <div className="flex flex-wrap gap-1.5">
            <span className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full text-xs">{role.type}</span>
            <span className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full text-xs flex items-center gap-1">
              <MapPin className="w-3 h-3" />
              {role.location}
            </span>
          </div>
        </div>
        
        {/* Bottom Row */}
        <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-100">
          <span className="text-gray-400 text-xs">{role.hiredRecently} hired recently</span>
          <span className="text-indigo-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
            View →
          </span>
        </div>
      </div>
    </Link>
  );
};

export default RoleCard;
